/* global */
(function (ns) {
    'use strict';

    ns.utilities = ns.utilities || {};

    ns.utilities.ready = function ready(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    };

    ns.utilities.base64 = {
        isBase64: function (str) {
            try {
                return btoa(atob(str)) === str;
            } catch (err) {
                return false;
            }
        },
        utf8ToBase64: function (str) {
            return window.btoa(encodeURIComponent(str));
        },
        base64ToUtf8: function (str) {
            return decodeURIComponent(window.atob(str));
        }
    };

    ns.utilities.localStorage = {
        isAvailable: function isAvailable() {
            return typeof window.Storage !== 'undefined';
        },
        set: function set(name, value) {
            return this.isAvailable() && localStorage.setItem(name, value);
        },
        get: function get(name) {
            return this.isAvailable() && localStorage.getItem(name);
        },
        remove: function remove(name) {
            return this.isAvailable() && localStorage.removeItem(name);
        }
    };

    ns.utilities.appendScript = function appendScript(callback, url, id) {
        var head = document.getElementsByTagName('head')[0],
            existingElement = document.getElementById(id),
            js = document.createElement('script');
        if (existingElement) { return; }
        js.src = url;
        js.onreadystatechange = callback;
        js.onload = callback;
        head.appendChild(js);
    };

    ns.utilities.isDev = function isDev() {
        var vm = '.vm',
            ci = '.ci',
            hostName = window.location.hostname;
        return (hostName.indexOf(vm) !== -1) || (hostName.indexOf(ci) !== -1);
    };

    ns.utilities.getQueryParam = function getQueryParam(variable) {
        var query = window.location.search.substring(1),
            vars = query.split('&'),
            i, pair;
        for (i = 0; i < vars.length; i++) {
            pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        return null;
    };

    ns.utilities.removeQueryParam = function removeQueryParam(variable) {
        var query = window.location.search.substring(1),
            vars = query.split('&');
        if (vars.length >= 2) {
            var prefix = encodeURIComponent(variable) + '=',
                pars = vars[1].split(/[&;]/g);

            // reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                // idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            query = vars[0] + '?' + pars.join('&');
            return query;
        } else {
            return query;
        }
    };

    ns.utilities.updateQueryStringParam = function updateQueryStringParam(key, value) {
        var updateRegex = new RegExp('([?&])' + key + '[^&]*'),
            removeRegex = new RegExp('([?&])' + key + '=[^&;]+[&;]?'),
            baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
            urlQueryString = document.location.search,
            newParam = key + '=' + value,
            params = '?' + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
            if (typeof value === 'undefined' || value === null || value === '') { // Remove param if value is empty
                params = urlQueryString.replace(removeRegex, '$1');
                params = params.replace(/[&;]$/, '');

            } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
                params = urlQueryString.replace(updateRegex, '$1' + newParam);

            } else { // Otherwise, add it to end of query string
                params = urlQueryString + '&' + newParam;
            }
        }

        // no parameter was set so we don't need the question mark
        params = (params === '?') ? '' : params;

        window.history.replaceState({}, '', baseUrl + params);
    };

    ns.utilities.objectToQueryString = function objectToQueryString(obj) {
        var query = Object.keys(obj)
            .filter(function (key) { return obj[key] !== '' && obj[key] !== null; })
            .map(function (key) { return key + '=' + obj[key]; })
            .join('&');
        return query.length > 0 ? '?' + query : null;
    };

    ns.utilities.queryStringToObject = function queryStringToObject(string) {
        var pairs = string.slice(1).split('&'),
            result = {};

        pairs.forEach(function (pair) {
            var pairSplit = pair.split('=');
            result[pairSplit[0]] = decodeURIComponent(pairSplit[1] || '');
        });

        return result;
    };

}(window.Namespace));
